var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatSpeed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 213.66 187.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "33.47 0 0 0 77.98 93.98 0 187.97 33.47 187.97 112.38 93.98 33.47 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "134.75 0 71.28 0 149.26 93.98 71.28 187.97 134.75 187.97 213.66 93.98 134.75 0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatSpeed);
export default __webpack_public_path__ + "static/media/stat-speed.dc5056d0ae8170de5fe317c70bbf2e60.svg";
export { ForwardRef as ReactComponent };